// import React, { useEffect } from "react";
// import MultiSelect from "../../../../Components/Utils/MultiSelect";
// import { useFormik } from "formik";
// import { useToast } from "../../../../Components/Others/ToastServices";
// import { TextMediumSM } from "../../../../Components/Text/MediumText";
// import {
//   CancelButton,
//   SubmitButton,
// } from "../../../../Components/Utils/Buttons";
// import FormikSelectTwo from "../../../../Components/Utils/Select";
// import axiosInstance from "../../../../Services/axiosCommon";
// import { useState } from "react";
// import * as yup from "yup";
// import UseDropDown from "../../../../Components/Hooks/useDropDown";
// import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
// import EditIcon from "../../../../Components/Icons/Edit";
// import { NuInput } from "../../../../Components/Utils/Input";
// import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";

// function FireSysytemInsp() {
//   const toast = useToast();
//     const { value: PurchaseRequestApprovalStatus } = useFetchMataData(
//       `/dropdown/dropdown-details/`,
//       "ApprovalStatus_CO"
//     );

//       const { data: form } = UseDropDownNew(`/form/drop-down`);
    
//     const { data: user } = UseDropDown("/user/drop-down");
//     const [data, setData] = useState([]);
//     const [showFilterDialog, setShowFilterDialog] = useState(false);
//     const getData = () => {
//       axiosInstance
//         .get("/status-permission/by-module/customer_order")
//         .then((res) => {
//           console.log("ss", res);
//           setData(res?.data?.data || []);
//         })
//         .catch(() => {
//           toast.open({
//             type: "error",
//             message: "Error",
//             description: "Failed to fetch data.",
//           });
//         });
//     };
  
//     useEffect(() => {
//       getData();
//     }, []);
//     const [createNew, setCreateNew] = useState({
//     //   module: "customer_order",
//       status: "",
//       users: "",
//       formSelection: "",
//     });
//     const formik = useFormik({
//       enableReinitialize: true,
//       initialValues: createNew,
//       validateOnChange: false,
//       validateOnBlur: false,
//       validationSchema: yup.object({
//         // email: yup.string().required('Email is required!'),
//       }),
//       onSubmit: async (value, { resetForm }) => {
//         axiosInstance.post("/status-permission/multi-add", value).then((res) => {
         
//         });
//       },
//     });
//     const [editDataStatus, setEditDataStatus] = useState("");
//     const [editApprovalType, setEditApprovalType] = useState("");
//     // console.log("vvv",editApprovalType);
//     const test = () => {
//       let temp = [];
//       Object.keys(data).map((key) => {
//         if (key === editDataStatus) {
//           data[editDataStatus].map((item) => {
//             console.log("value", item?.userId);
//             temp.push(item?.userId);
//           });
//           // return temp;
//         }
//         // return null;
//       });
//       return temp;
//     };
  
//     const [createNewEdit, setCreateNewEdit] = useState({
//     //   module: "customer_order",
//       status: "",
//       users: "",
//       formSelection: ""
//     });
  
//     useEffect(() => {
//       setCreateNewEdit({
//         module: "customer_order",
//         status: editDataStatus,
//         users: test() || [],
//         approvalType: editApprovalType || "",
//       });
//     }, [editDataStatus,editApprovalType]);
  
//     const formikEdit = useFormik({
//       enableReinitialize: true,
//       initialValues: createNewEdit,
//       validateOnChange: false,
//       validateOnBlur: false,
//       validationSchema: yup.object({
//         // email: yup.string().required('Email is required!'),
//       }),
//       onSubmit: async (value, { resetForm }) => {
//         const valueData = {
//           ...value,
//         //   module: "customer_order",
//         //   status: editDataStatus,
//         };
//         axiosInstance
//           .post("/status-permission/multi-add", valueData)
//           .then((res) => {
           
//           });
//       },
//     });
  
//     const getInitials = (name) => {
//       const names = name.split(" ");
//       if (names.length > 1) {
//         return names[0][0] + names[1][0];
//       }
//       return names[0][0];
//     };
//     const closeFilterDialog = () => {
//       setShowFilterDialog(false);
//     };
//     return (
//       <>
//         <style jsx>{`
//           .circle-container .circle {
//             position: relative;
//             display: inline-block;
//           }
  
//           .circle-container .circle .circle-tooltip {
//             visibility: hidden;
//             width: auto;
//             background-color: #fff;
//             color: #555;
//             text-align: center;
//             border-radius: 5px;
//             padding: 5px;
//             position: absolute;
//             z-index: 20;
//             bottom: 100%; /* Position the tooltip above the circle */
//             left: 50%;
//             transform: translateX(-50%);
//             opacity: 0;
//             transition: opacity 0.3s;
//             border: 1px solid #048178;
//           }
  
//           .circle-container .circle:hover .circle-tooltip {
//             visibility: visible;
//             opacity: 1;
//           }
//         `}</style>
//         <div className="ml-5">
//           <TextMediumSM content={"Inspection"} />
//         </div>
//         <form onSubmit={formik.handleSubmit}>
//           <div className="flex justify-start">
//             <NuInput
//             type="text"
//               label="Name"
//               placeholder="Choose"
//               Options={user}
//               formik={formik}
//               name="users"
//               width="w-full md:w-1/2 lg:w-1/4"
//             />
//              <MultiSelect
//                       label="Form"
//                       Options={form}
//                       formik={formik}
//                       placeholder="Choose"
//                       name="formSelection"
//                       width="w-full md:w-1/2 lg:w-1/4"
//                     />
//             <div className="w-10 h-12 mt-11">
//               <SubmitButton name="Add" />
//             </div>
//           </div>
//         </form>
//         <table className=" w-[75%] h-64 ml-5 overflow-y-auto mt-2">
//           <thead>
//             <tr className="border-b border-black">
//               <th className=" w-[30%] text-left text-sm font-medium py-2 px-4">
//                 Name
//               </th>
//               <th className=" w-[30%] text-left text-sm font-medium py-2 px-4">
//                 Forms
//               </th>
//               <th className=" w-[10%] text-left text-sm font-medium py-2 px-4">
//                 Edit
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {data &&
//               Object.keys(data).map((value, index) => {
//                 console.log("ddddddddd", data[value][0].approvalType);
//                 return (
//                   <tr className="even:bg-white odd:bg-slate-50" key={index}>
//                     <td className="w-[30%] text-xs px-4 pt-5">{value || "-"}</td>
                  
//                     <td className="w-[30%] text-xs px-4 pt-5">
//                       {data[value][0].formSelection || "-"}
//                     </td>
//                     <td className="w-[10%] pt-3">
//                       <div
//                         className="flex justify-center cursor-pointer"
//                         onClick={() => {
//                           setShowFilterDialog(true);
//                           setEditDataStatus(value);
//                           setEditApprovalType(data[value][0].approvalType);
//                         }}
//                       >
//                         <EditIcon color="yellow" />
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//           </tbody>
//         </table>
//         {showFilterDialog && (
//           <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
//             <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
//               <h2 className="text-xl mb-4">Edit Permission</h2>
//               <form onSubmit={formikEdit.handleSubmit}>
//                 <div className="flex flex-col mb-4">
//                   <NuInput
//             type="text"
//               label="Name"
//               placeholder="Choose"
//               Options={user}
//               formik={formik}
//               name="users"
//               width="w-full md:w-1/2 lg:w-1/4"
//             />
//              <MultiSelect
//                       label="Form"
//                       Options={form}
//                       formik={formik}
//                       placeholder="Choose"
//                       name="formSelection"
//                       width="w-full md:w-1/2 lg:w-1/4"
//                     />
//                 </div>
//                 <div className="flex justify-end gap-2">
//                   <CancelButton handleClick={closeFilterDialog} />
//                   <SubmitButton name="Submit" />
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//       </>
//     );
// }

// export default FireSysytemInsp


import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { NuInput } from "../../../../Components/Utils/Input";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import { TextMediumSM } from "../../../../Components/Text/MediumText";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import EditIcon from "../../../../Components/Icons/Edit";
import DeleteIcon from "../../../../Components/Icons/Delete";
import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";

function FireSysytemInsp() {
  const [data, setData] = useState({});
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [editDataStatus, setEditDataStatus] = useState("");
  const [editApprovalType, setEditApprovalType] = useState("");

  // Dummy dropdowns
  // const user = [
  //   { label: "Sherin M", value: "Sherin M" },
  //   { label: "Rahul", value: "Rahul" },
  //   { label: "Anjali", value: "Anjali" },
  // ];
       const { data: form } = UseDropDownNew(`/form/drop-down`);
 

  const [createNew, setCreateNew] = useState({
    users: "",
    formSelection: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validationSchema: yup.object({}),
    onSubmit: (value, { resetForm }) => {
      const newData = {
        [value.users]: [
          {
            ...value,
            approvalType: "default",
          },
        ],
      };
      setData((prev) => ({ ...prev, ...newData }));
      resetForm();
    },
  });

  const [createNewEdit, setCreateNewEdit] = useState({
    users: "",
    formSelection: "",
  });

  useEffect(() => {
    if (editDataStatus) {
      const currentData = data[editDataStatus]?.[0] || {};
      setCreateNewEdit({
        users: editDataStatus,
        formSelection: currentData.formSelection || "",
      });
    }
  }, [editDataStatus]);

  const formikEdit = useFormik({
    enableReinitialize: true,
    initialValues: createNewEdit,
    validationSchema: yup.object({}),
    onSubmit: (value) => {
      const updatedData = {
        [value.users]: [
          {
            ...value,
            approvalType: "default",
          },
        ],
      };

      // Remove old key if changed
      if (value.users !== editDataStatus) {
        const copy = { ...data };
        delete copy[editDataStatus];
        setData({ ...copy, ...updatedData });
      } else {
        setData((prev) => ({ ...prev, ...updatedData }));
      }

      setShowFilterDialog(false);
    },
  });

  const handleDelete = (key) => {
    const copy = { ...data };
    delete copy[key];
    setData(copy);
  };

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  return (
    <>
      <div className="ml-5">
        <SettingHeading content={"Inspection"} />
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="flex justify-start items-end gap-2  mt-4 flex-wrap">
          <NuInput
            type="text"
            label="Name"
            placeholder="Choose"
            // Options={user}
            formik={formik}
            name="users"
            width="w-full md:w-1/2 lg:w-1/4"
          />
          <MultiSelect
            label="Form"
            Options={form}
            formik={formik}
            placeholder="Choose"
            name="formSelection"
            width="w-full md:w-1/2 lg:w-1/4"
          />
            <div className="w-10 h-12 mt-11">
                              <SubmitButton name="Add" />
                            </div>
        </div>
      </form>

      <table className="w-[90%] ml-5 mt-6">
        <thead>
          <tr className="border-b border-black">
            <th className="text-left text-sm py-2 px-4">Name</th>
            <th className="text-left text-sm py-2 px-4">Forms</th>
            <th className="text-left text-sm py-2 px-4">Action</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(data).map((key, index) => (
            <tr className="even:bg-white odd:bg-slate-50" key={index}>
              <td className="text-xs px-4 pt-5">{key}</td>
              <td className="text-xs px-4 pt-5">
                {data[key]?.[0]?.formSelection || "-"}
              </td>
              <td className="pt-3 flex">
                <div
                  className="flex justify-center cursor-pointer"
                  onClick={() => {
                    setShowFilterDialog(true);
                    setEditDataStatus(key);
                    setEditApprovalType(data[key]?.[0]?.approvalType);
                  }}
                >
                  <EditIcon color="yellow" />
                </div>
                <div
                  className="flex justify-center cursor-pointer"
                  onClick={() => handleDelete(key)}
                >
                  <DeleteIcon color="red" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Edit Permission</h2>
            <form onSubmit={formikEdit.handleSubmit}>
              <div className="flex flex-col mb-4 gap-4">
                <NuInput
                  type="text"
                  label="Name"
                  placeholder="Choose"
                  // Options={user}
                  formik={formikEdit}
                  name="users"
                />
                <MultiSelect
                  label="Form"
                  Options={form}
                  formik={formikEdit}
                  placeholder="Choose"
                  name="formSelection"
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Submit" />
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default FireSysytemInsp;
